<template>
  <v-app>
    <core-navbar />
    <v-main>
      <router-view v-wechat-title='$route.meta.title'/>
    </v-main>
  </v-app>
</template>


<script>
export default {
  name: 'App',
  
  components: {
    CoreNavbar: () => import("@/components/NavBar"),
  },

  data: () => ({
    isRouterAlive: true,
  }),
};
</script>


<style lang="css" scoped>
.v-application {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  background-color: #F5F5F5 !important;
}
.bbox {
  bottom: 80px !important;
  right: 0 !important;
}
</style>
